import { watch } from 'vue'
import { defineNuxtPlugin } from 'nuxt/app'

// The route middleware catches a dead session on page load. A tab left open overnight only
// learns about it when nuxt-auth refreshes the session (window focus, periodic refresh), so
// react to the RefreshAccessTokenError right then instead of waiting for requests to fail.
export default defineNuxtPlugin(() => {
  const tokenHelper = useAuthToken()

  watch(() => tokenHelper.hasRefreshError(), (isDead) => {
    if (isDead) {
      tokenHelper.handleDeadSession({ respectDevMode: false })
    }
  })
})
